import React from "react";
import { Tag } from "antd";
import { IBetaTag } from "./interface";
import "./index.less";

const ZBetaTag: React.FC<IBetaTag> = ({
	className,
	tagLabel = "BETA",
	...rest
}) => (
	<Tag className={`z-beta-tag ${className ?? ""}`} {...rest}>
		{tagLabel}
	</Tag>
);

export default ZBetaTag;
